<template>
    <div
        v-if="items.length"
        class="mt-4 grid gap-y-2.5"
    >
        <div
            class="p-2 flex items-center bg-purple-70 dark:bg-blue-770 rounded-1.25"
            v-for="(item, index) in items"
            :key="index"
        >
            <FileTwoIcon class="mr-1.5 min-w-9 min-h-9 max-w-9 max-h-9 text-gray-200"/>

            <div class="w-full grid gap-y-1">
                <div class="w-full flex items-center justify-between">
                    <div
                        class="text-xs font-medium"
                        :class="[
                            maxSize && maxSize < getMbFromBytes(item.size)
                            ? 'text-red'
                            : 'text-gray-370 dark:text-white'
                        ]"
                    >
                        {{ fileName(item) }}
                    </div>
                </div>

                <div
                    v-if="item.size"
                    class="text-xs text-gray-280"
                    :class="[
                        maxSize && maxSize < getMbFromBytes(item.size)
                        ? 'text-red'
                        : 'text-gray-280'
                    ]"
                >
                    {{ formatBytes(item.size) }}
                </div>
            </div>

            <DeleteIcon24x24
                class="text-gray-200 hover:text-primary transition-colors cursor-pointer"
                @click="onRemove(index)"
            />
        </div>
    </div>
</template>

<script setup>
import FileTwoIcon from '@/components/icons/FileTwoIcon.vue'
import DeleteIcon24x24 from '@/components/icons/delete/DeleteIcon24x24.vue'

import { formatBytes, getMbFromBytes, truncateFile } from '@/helpers/app-helper'

const props = defineProps({
    truncateLength: {
        type: Number,
        default: 50,
    },
    maxSize: {
        type: Number,
        default: null,
    },
})

const items = defineModel('items', { type: Array, default: () => [] })

function fileName({ name, filename }) {
    return truncateFile(name || filename, props.truncateLength)
}

function onRemove(index) {
    items.value = items.value.filter((item, i) => index !== i)
}
</script>
